import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import SocialsNavigation from './SocialsNavigation';
import { useLocation, useNavigate } from 'react-router-dom';

const SocialsPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location.state;
    const [iframeHeight, setIframeHeight] = useState(window.innerHeight - 52);
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [activePage, setActivePage] = useState<string>('dashboard');

    // useEffect(() => {
    //     if (!data || !data.url) {
    //         navigate('/');
    //     }
    // }, [data, navigate]);

    useEffect(() => {
        const handleResize = () => {
            setIframeHeight(window.innerHeight - 52);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const navigateDashboard = (page: string, element: HTMLElement) => {
        setActivePage(page);
        const iframe = document.getElementById('embedded-dashboard') as HTMLIFrameElement;
        const iframeWindow = iframe?.contentWindow;

        if (iframeWindow) {
            iframeWindow.postMessage({ page }, '*');
        }
    };

    return (
        <>
            <Row className="page">
                <SocialsNavigation
                    navigateDashboard={navigateDashboard}
                    activePage={activePage}
                    iframeHeight={iframeHeight}
                />
                <Col id="parent" className="parent-div m-0 p-0" md={10}>
                    <iframe
                        className=""
                        src={
                            data && data.url
                                ? data.url
                                : 'https://pixii.cldportal.com/embedded-dashboard/page=dashboard'
                        }
                        id="embedded-dashboard"
                        ref={iframeRef}
                        title="social_dashboard"
                        width="100%"
                        height={iframeHeight}
                        allow="clipboard-read; clipboard-write"
                    ></iframe>
                </Col>
            </Row>
        </>
    );
};

export default SocialsPage;
